export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 9a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75H6.5v2H5V9h3.25zM6.5 11.5h1v-1h-1v1zM12.25 9c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0112.25 15H10V9h2.25zm-.75 4.5h.75a.25.25 0 00.25-.25v-2.5a.25.25 0 00-.25-.25h-.75v3z\" fill=\"#7B61FF\"/><path d=\"M19 10.5h-2.5v1h2V13h-2v2H15V9h4v1.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-19a1 1 0 01-1-1v-15a1 1 0 011-1h19zm-18 15h17v-13h-17v13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};